var map = {
	"./AppAssets/animation/AnimationConfig": 87498,
	"./AppAssets/animation/AnimationConfig.json": 87498,
	"./AppAssets/animation/AnimationConfig_en": 30711,
	"./AppAssets/animation/AnimationConfig_en.json": 30711,
	"./AppAssets/animation/icon/icon_action_female_bainian.png": 89675,
	"./AppAssets/animation/icon/icon_action_female_baoquan.png": 74601,
	"./AppAssets/animation/icon/icon_action_female_bixin.png": 96698,
	"./AppAssets/animation/icon/icon_action_female_danshouzhanshi.png": 2796,
	"./AppAssets/animation/icon/icon_action_female_danshouzhiyi.png": 5991,
	"./AppAssets/animation/icon/icon_action_female_dazhaohu.png": 47273,
	"./AppAssets/animation/icon/icon_action_female_dianzan.png": 91379,
	"./AppAssets/animation/icon/icon_action_female_gaoxing.png": 89910,
	"./AppAssets/animation/icon/icon_action_female_guzhang.png": 42543,
	"./AppAssets/animation/icon/icon_action_female_huanjiao.png": 49510,
	"./AppAssets/animation/icon/icon_action_female_huanzhuang.png": 5664,
	"./AppAssets/animation/icon/icon_action_female_huxi.png": 666,
	"./AppAssets/animation/icon/icon_action_female_jiaotan.png": 3885,
	"./AppAssets/animation/icon/icon_action_female_jiaotan1.png": 4348,
	"./AppAssets/animation/icon/icon_action_female_jiaotan2.png": 22136,
	"./AppAssets/animation/icon/icon_action_female_jiaotan3.png": 25010,
	"./AppAssets/animation/icon/icon_action_female_ok.png": 61230,
	"./AppAssets/animation/icon/icon_action_female_ok_v02.png": 52417,
	"./AppAssets/animation/icon/icon_action_female_rouyan.png": 18847,
	"./AppAssets/animation/icon/icon_action_female_shenlanyao.png": 39589,
	"./AppAssets/animation/icon/icon_action_female_shuaku1.png": 90215,
	"./AppAssets/animation/icon/icon_action_female_shuaku2.png": 25056,
	"./AppAssets/animation/icon/icon_action_female_zoulu.png": 60607,
	"./AppAssets/animation/icon/icon_action_female_zuoxiahuxi.png": 86776,
	"./AppAssets/animation/icon/icon_action_female_zuoyi.png": 61635,
	"./AppAssets/animation/icon/icon_action_female_zuoyoukan.png": 2674,
	"./AppAssets/animation/icon/icon_action_male_bainian.png": 93041,
	"./AppAssets/animation/icon/icon_action_male_baoquan.png": 21694,
	"./AppAssets/animation/icon/icon_action_male_bixin.png": 29299,
	"./AppAssets/animation/icon/icon_action_male_danshouzhanshi.png": 87980,
	"./AppAssets/animation/icon/icon_action_male_danshouzhiyi.png": 47520,
	"./AppAssets/animation/icon/icon_action_male_dazhaohu.png": 57244,
	"./AppAssets/animation/icon/icon_action_male_dianzan.png": 15735,
	"./AppAssets/animation/icon/icon_action_male_gaoxing.png": 43230,
	"./AppAssets/animation/icon/icon_action_male_guzhang.png": 80975,
	"./AppAssets/animation/icon/icon_action_male_huanjiao.png": 98624,
	"./AppAssets/animation/icon/icon_action_male_huanzhuang.png": 26781,
	"./AppAssets/animation/icon/icon_action_male_huxi.png": 30542,
	"./AppAssets/animation/icon/icon_action_male_jiaotan.png": 4900,
	"./AppAssets/animation/icon/icon_action_male_jiaotan1.png": 15586,
	"./AppAssets/animation/icon/icon_action_male_jiaotan2.png": 30354,
	"./AppAssets/animation/icon/icon_action_male_jiaotan3.png": 4626,
	"./AppAssets/animation/icon/icon_action_male_ok.png": 32389,
	"./AppAssets/animation/icon/icon_action_male_ok_v02.png": 17953,
	"./AppAssets/animation/icon/icon_action_male_rouyan.png": 22738,
	"./AppAssets/animation/icon/icon_action_male_shenlanyao.png": 33256,
	"./AppAssets/animation/icon/icon_action_male_shuaku1.png": 24471,
	"./AppAssets/animation/icon/icon_action_male_shuaku2.png": 78335,
	"./AppAssets/animation/icon/icon_action_male_zoulu.png": 67307,
	"./AppAssets/animation/icon/icon_action_male_zuoxiahuxi.png": 23705,
	"./AppAssets/animation/icon/icon_action_male_zuoyi.png": 87512,
	"./AppAssets/animation/icon/icon_action_male_zuoyoukan.png": 24867,
	"./AppAssets/avatar/0rhmtzCu/avatar": 33438,
	"./AppAssets/avatar/0rhmtzCu/avatar.json": 33438,
	"./AppAssets/avatar/0rhmtzCu/avatar.png": 88141,
	"./AppAssets/avatar/hGkXsPkK/avatar": 92567,
	"./AppAssets/avatar/hGkXsPkK/avatar.json": 92567,
	"./AppAssets/avatar/hGkXsPkK/avatar.png": 1741,
	"./AppAssets/bodyShape/bodyPitch": 57277,
	"./AppAssets/bodyShape/bodyPitch.json": 57277,
	"./AppAssets/bodyShape/bodyPitchSort": 42818,
	"./AppAssets/bodyShape/bodyPitchSort.json": 42818,
	"./AppAssets/bodyShape/bodyPitchSort_en": 557,
	"./AppAssets/bodyShape/bodyPitchSort_en.json": 557,
	"./AppAssets/bodyShape/bodyPitch_en": 28301,
	"./AppAssets/bodyShape/bodyPitch_en.json": 28301,
	"./AppAssets/bodyShape/facepup_config_baseHeadBody": 80220,
	"./AppAssets/bodyShape/facepup_config_baseHeadBody.json": 80220,
	"./AppAssets/bodyShape/facepup_config_eightHeadBody": 91862,
	"./AppAssets/bodyShape/facepup_config_eightHeadBody.json": 91862,
	"./AppAssets/bodyShape/facepup_config_nineHeadBody": 44031,
	"./AppAssets/bodyShape/facepup_config_nineHeadBody.json": 44031,
	"./AppAssets/bodyShape/facepup_config_sevenHeadBody": 37208,
	"./AppAssets/bodyShape/facepup_config_sevenHeadBody.json": 37208,
	"./AppAssets/bodyShape/facepup_config_sixHeadBody": 79473,
	"./AppAssets/bodyShape/facepup_config_sixHeadBody.json": 79473,
	"./AppAssets/bodyShape_icon/fu_eight_head_body.png": 55827,
	"./AppAssets/bodyShape_icon/fu_five_head_body.png": 98190,
	"./AppAssets/bodyShape_icon/fu_nine_head_body.png": 79099,
	"./AppAssets/bodyShape_icon/fu_seven_head_body.png": 68806,
	"./AppAssets/bodyShape_icon/fu_six_head_body.png": 49542,
	"./AppAssets/edit_color_list": 68018,
	"./AppAssets/edit_color_list.json": 68018,
	"./AppAssets/edit_config": 74911,
	"./AppAssets/edit_config.json": 74911,
	"./AppAssets/edit_item_config_list": 4472,
	"./AppAssets/edit_item_config_list.json": 4472,
	"./AppAssets/edit_item_config_list_en": 99801,
	"./AppAssets/edit_item_config_list_en.json": 99801,
	"./AppAssets/edit_item_list": 42681,
	"./AppAssets/edit_item_list.json": 42681,
	"./AppAssets/facepup/MeshConfig": 10563,
	"./AppAssets/facepup/MeshConfig.json": 10563,
	"./AppAssets/facepup/MeshLanguage": 5100,
	"./AppAssets/facepup/MeshLanguage.json": 5100,
	"./AppAssets/facepup/MeshLanguage_en": 61110,
	"./AppAssets/facepup/MeshLanguage_en.json": 61110,
	"./AppAssets/facepup/MeshPoints": 92947,
	"./AppAssets/facepup/MeshPoints.json": 92947,
	"./AppAssets/facepup/MeshSimpleConfig": 18866,
	"./AppAssets/facepup/MeshSimpleConfig.json": 18866,
	"./AppAssets/facepup/facepup_icon": 11249,
	"./AppAssets/facepup/facepup_icon.json": 11249,
	"./AppAssets/facepup_icon/icon_drawer_base_of_nose.png": 52111,
	"./AppAssets/facepup_icon/icon_drawer_bridge.png": 62503,
	"./AppAssets/facepup_icon/icon_drawer_corner_of_mouth.png": 75551,
	"./AppAssets/facepup_icon/icon_drawer_corner_of_mouth_small.png": 37921,
	"./AppAssets/facepup_icon/icon_drawer_eye.png": 46153,
	"./AppAssets/facepup_icon/icon_drawer_eye_inner.png": 98876,
	"./AppAssets/facepup_icon/icon_drawer_eye_outside.png": 66371,
	"./AppAssets/facepup_icon/icon_drawer_eyebrow(1).png": 40693,
	"./AppAssets/facepup_icon/icon_drawer_eyebrow(2).png": 32141,
	"./AppAssets/facepup_icon/icon_drawer_eyebrow(3).png": 48718,
	"./AppAssets/facepup_icon/icon_drawer_eyebrow.png": 11435,
	"./AppAssets/facepup_icon/icon_drawer_female_cheek.png": 78459,
	"./AppAssets/facepup_icon/icon_drawer_female_cheekbone.png": 82126,
	"./AppAssets/facepup_icon/icon_drawer_female_chin.png": 5864,
	"./AppAssets/facepup_icon/icon_drawer_female_chin_tip.png": 60284,
	"./AppAssets/facepup_icon/icon_drawer_female_forehead.png": 5649,
	"./AppAssets/facepup_icon/icon_drawer_female_lower_face.png": 78552,
	"./AppAssets/facepup_icon/icon_drawer_female_mandible.png": 61493,
	"./AppAssets/facepup_icon/icon_drawer_female_mandibular_angle.png": 67988,
	"./AppAssets/facepup_icon/icon_drawer_female_masseter.png": 66835,
	"./AppAssets/facepup_icon/icon_drawer_female_ophryon.png": 59559,
	"./AppAssets/facepup_icon/icon_drawer_female_temple.png": 93290,
	"./AppAssets/facepup_icon/icon_drawer_head_of_nose.png": 28622,
	"./AppAssets/facepup_icon/icon_drawer_lower_eyelid_inner(1).png": 21732,
	"./AppAssets/facepup_icon/icon_drawer_lower_eyelid_inner.png": 14182,
	"./AppAssets/facepup_icon/icon_drawer_lower_eyelid_mid.png": 26955,
	"./AppAssets/facepup_icon/icon_drawer_lower_eyelid_outside.png": 15667,
	"./AppAssets/facepup_icon/icon_drawer_lower_lip.png": 74963,
	"./AppAssets/facepup_icon/icon_drawer_male_cheek.png": 19793,
	"./AppAssets/facepup_icon/icon_drawer_male_cheekbone.png": 52212,
	"./AppAssets/facepup_icon/icon_drawer_male_chin.png": 80432,
	"./AppAssets/facepup_icon/icon_drawer_male_chin_tip.png": 35518,
	"./AppAssets/facepup_icon/icon_drawer_male_forehead.png": 35441,
	"./AppAssets/facepup_icon/icon_drawer_male_lower_face.png": 866,
	"./AppAssets/facepup_icon/icon_drawer_male_mandible.png": 39872,
	"./AppAssets/facepup_icon/icon_drawer_male_mandibular_angle.png": 99923,
	"./AppAssets/facepup_icon/icon_drawer_male_masseter.png": 1784,
	"./AppAssets/facepup_icon/icon_drawer_male_temple.png": 61925,
	"./AppAssets/facepup_icon/icon_drawer_mentolabial_sulcus.png": 88288,
	"./AppAssets/facepup_icon/icon_drawer_middle_lip_down.png": 83635,
	"./AppAssets/facepup_icon/icon_drawer_middle_lip_up.png": 41398,
	"./AppAssets/facepup_icon/icon_drawer_mouth.png": 97393,
	"./AppAssets/facepup_icon/icon_drawer_nose.png": 44874,
	"./AppAssets/facepup_icon/icon_drawer_nosewing.png": 13004,
	"./AppAssets/facepup_icon/icon_drawer_root.png": 73579,
	"./AppAssets/facepup_icon/icon_drawer_side_of_nose.png": 7308,
	"./AppAssets/facepup_icon/icon_drawer_upper_eyelid_inner.png": 78995,
	"./AppAssets/facepup_icon/icon_drawer_upper_eyelid_mid.png": 86409,
	"./AppAssets/facepup_icon/icon_drawer_upper_eyelid_outside.png": 24178,
	"./AppAssets/facepup_icon/icon_drawer_upper_lip.png": 129,
	"./AppAssets/facepup_icon/icon_male_drawer_ophryon.png": 43762,
	"./AppAssets/icon/avatarlist.png": 68829,
	"./AppAssets/icon/avatarlist_sel.png": 23197,
	"./AppAssets/icon/beard.png": 96110,
	"./AppAssets/icon/beard_color.png": 21173,
	"./AppAssets/icon/beard_color_sel.png": 19339,
	"./AppAssets/icon/beard_sel.png": 39899,
	"./AppAssets/icon/blush.png": 29110,
	"./AppAssets/icon/blush_sel.png": 23713,
	"./AppAssets/icon/body.png": 54444,
	"./AppAssets/icon/bodyShape.png": 97605,
	"./AppAssets/icon/bodyShape_sel.png": 47740,
	"./AppAssets/icon/body_sel.png": 83090,
	"./AppAssets/icon/boots.png": 99612,
	"./AppAssets/icon/boots_sel.png": 93224,
	"./AppAssets/icon/brow.png": 87225,
	"./AppAssets/icon/brow_sel.png": 19166,
	"./AppAssets/icon/cloth.png": 66678,
	"./AppAssets/icon/cloth_sel.png": 55977,
	"./AppAssets/icon/coat.png": 22003,
	"./AppAssets/icon/coat_sel.png": 94987,
	"./AppAssets/icon/ear.png": 86935,
	"./AppAssets/icon/ear_sel.png": 96372,
	"./AppAssets/icon/earring.png": 62829,
	"./AppAssets/icon/earring_sel.png": 14153,
	"./AppAssets/icon/eye.png": 88043,
	"./AppAssets/icon/eye_sel.png": 57905,
	"./AppAssets/icon/eyebrow_color.png": 73999,
	"./AppAssets/icon/eyebrow_color_sel.png": 77403,
	"./AppAssets/icon/eyelash.png": 61803,
	"./AppAssets/icon/eyelash_sel.png": 22641,
	"./AppAssets/icon/eyeshadow.png": 9560,
	"./AppAssets/icon/eyeshadow_sel.png": 48820,
	"./AppAssets/icon/eyeshadowcolor.png": 47959,
	"./AppAssets/icon/eyeshadowcolor_sel.png": 26733,
	"./AppAssets/icon/face.png": 81684,
	"./AppAssets/icon/face_sel.png": 90075,
	"./AppAssets/icon/facepainting.png": 3427,
	"./AppAssets/icon/facepainting_sel.png": 93803,
	"./AppAssets/icon/faceshield.png": 82790,
	"./AppAssets/icon/faceshield_sel.png": 52502,
	"./AppAssets/icon/glasses.png": 97275,
	"./AppAssets/icon/glasses_sel.png": 67127,
	"./AppAssets/icon/hair.png": 34730,
	"./AppAssets/icon/hair_color.png": 36661,
	"./AppAssets/icon/hair_color_sel.png": 9203,
	"./AppAssets/icon/hair_sel.png": 33513,
	"./AppAssets/icon/hat.png": 26782,
	"./AppAssets/icon/hat_sel.png": 58789,
	"./AppAssets/icon/head.png": 65219,
	"./AppAssets/icon/head_sel.png": 94068,
	"./AppAssets/icon/head_selected.png": 44942,
	"./AppAssets/icon/hoodie.png": 67969,
	"./AppAssets/icon/hoodie_sel.png": 63651,
	"./AppAssets/icon/icon_custom_config.png": 31538,
	"./AppAssets/icon/icon_my.png": 29884,
	"./AppAssets/icon/icon_my_sel.png": 10081,
	"./AppAssets/icon/icon_set.png": 11673,
	"./AppAssets/icon/icon_tab1_bracelet_nor@3x.png": 42312,
	"./AppAssets/icon/icon_tab1_bracelet_sel@3x.png": 40230,
	"./AppAssets/icon/iris_color.png": 22127,
	"./AppAssets/icon/iris_color_sel.png": 18204,
	"./AppAssets/icon/lip.png": 20519,
	"./AppAssets/icon/lip_sel.png": 60429,
	"./AppAssets/icon/lipcolor.png": 79415,
	"./AppAssets/icon/lipcolor_sel.png": 45504,
	"./AppAssets/icon/lipmakeup.png": 26218,
	"./AppAssets/icon/lipmakeup_sel.png": 95226,
	"./AppAssets/icon/mouth.png": 93914,
	"./AppAssets/icon/mouth_sel.png": 36233,
	"./AppAssets/icon/necklace.png": 47043,
	"./AppAssets/icon/necklace_sel.png": 10519,
	"./AppAssets/icon/nose.png": 98841,
	"./AppAssets/icon/nose_sel.png": 34277,
	"./AppAssets/icon/ornament.png": 32332,
	"./AppAssets/icon/ornament_sel.png": 95727,
	"./AppAssets/icon/pants.png": 69733,
	"./AppAssets/icon/pants_sel.png": 55385,
	"./AppAssets/icon/pupil.png": 22936,
	"./AppAssets/icon/pupil_sel.png": 43506,
	"./AppAssets/icon/relieve.png": 5181,
	"./AppAssets/icon/rouge.png": 17234,
	"./AppAssets/icon/rouge_sel.png": 12550,
	"./AppAssets/icon/rougecolor.png": 60238,
	"./AppAssets/icon/rougecolor_sel.png": 82619,
	"./AppAssets/icon/shirt.png": 65299,
	"./AppAssets/icon/shirt_sel.png": 70559,
	"./AppAssets/icon/shoe.png": 14875,
	"./AppAssets/icon/shoe_sel.png": 77890,
	"./AppAssets/icon/shoes.png": 3889,
	"./AppAssets/icon/shoes_sel.png": 85632,
	"./AppAssets/icon/shorts.png": 59398,
	"./AppAssets/icon/shorts_sel.png": 90627,
	"./AppAssets/icon/skin_color.png": 74938,
	"./AppAssets/icon/skin_color_sel.png": 36485,
	"./AppAssets/icon/skirt.png": 27532,
	"./AppAssets/icon/skirt_sel.png": 70684,
	"./AppAssets/icon/suit.png": 77288,
	"./AppAssets/icon/suit_sel.png": 21677,
	"./AppAssets/icon/sweater.png": 95498,
	"./AppAssets/icon/sweater_sel.png": 37830,
	"./AppAssets/icon/trousers.png": 3691,
	"./AppAssets/icon/trousers_sel.png": 82680,
	"./AppAssets/icon/upper.png": 29569,
	"./AppAssets/icon/upper_sel.png": 81206,
	"./AppAssets/icon/wristwear.png": 31715,
	"./AppAssets/icon/wristwear_sel.png": 22377,
	"./AppAssets/skill_list": 63323,
	"./AppAssets/skill_list.json": 63323,
	"./AppAssets/voice_list": 58278,
	"./AppAssets/voice_list.json": 58278,
	"./slices/Infinity-1.7s-94px.gif": 10143,
	"./slices/Shot.png": 19671,
	"./slices/audition_play.gif": 75893,
	"./slices/background.png": 7057,
	"./slices/bar_edit@2x.png": 3910,
	"./slices/bar_generate@2x.png": 91069,
	"./slices/bar_interaction@2x.png": 61879,
	"./slices/base_of_nose@2x.png": 43595,
	"./slices/beard_nor@2x.png": 24208,
	"./slices/beard_sel@2x.png": 98661,
	"./slices/beardcolor_nor@2x.png": 55326,
	"./slices/beardcolor_sel@2x.png": 63502,
	"./slices/beautiful_pupil_nor@2x.png": 79184,
	"./slices/beautiful_pupil_sel@2x.png": 21265,
	"./slices/boots_nor@2x.png": 98898,
	"./slices/boots_sel@2x.png": 17704,
	"./slices/bracelet_nor@2x.png": 64690,
	"./slices/bracelet_sel@2x.png": 37528,
	"./slices/btn_play@3x.png": 55294,
	"./slices/clothes_nor@2x.png": 74541,
	"./slices/clothes_sel@2x.png": 18101,
	"./slices/coat_nor@2x.png": 81767,
	"./slices/coat_sel@2x.png": 37210,
	"./slices/completeset_nor@2x.png": 75575,
	"./slices/completeset_sel@2x.png": 29502,
	"./slices/corner_mouth@2x.png": 35544,
	"./slices/corner_mouth_small@2x.png": 85177,
	"./slices/drawer_bg2@2x.png": 96785,
	"./slices/ear_nor@2x.png": 38416,
	"./slices/ear_sel@2x.png": 41211,
	"./slices/earrings_nor@2x.png": 87846,
	"./slices/earrings_sel@2x.png": 85930,
	"./slices/eye@2x.png": 89401,
	"./slices/eye_inner@2x.png": 75953,
	"./slices/eye_nor@2x.png": 18554,
	"./slices/eye_outside@2x.png": 93453,
	"./slices/eye_sel@2x.png": 38654,
	"./slices/eyebrow@2x.png": 24816,
	"./slices/eyebrow_inner@2x.png": 45769,
	"./slices/eyebrow_mid@2x.png": 61548,
	"./slices/eyebrow_nor@2x.png": 20295,
	"./slices/eyebrow_outer@2x.png": 93481,
	"./slices/eyebrow_sel@2x.png": 75486,
	"./slices/eyebrowcolor_nor@2x.png": 39800,
	"./slices/eyebrowcolor_sel@2x.png": 71860,
	"./slices/eyecolor_nor@2x.png": 19369,
	"./slices/eyecolor_sel@2x.png": 38359,
	"./slices/eyelash_nor@2x.png": 50706,
	"./slices/eyelash_sel@2x.png": 66625,
	"./slices/eyelid_inner@2x.png": 12237,
	"./slices/eyeshadow_nor@2x.png": 86543,
	"./slices/eyeshadow_sel@2x.png": 41933,
	"./slices/eyeshadowcolor_nor@2x.png": 28618,
	"./slices/eyeshadowcolor_sel@2x.png": 64498,
	"./slices/face_nor@2x.png": 8771,
	"./slices/face_sel@2x.png": 47057,
	"./slices/facepainting_nor@2x.png": 93033,
	"./slices/facepainting_sel@2x.png": 83663,
	"./slices/facial_decoration_sel@2x.png": 71278,
	"./slices/female_cheek@2x.png": 16022,
	"./slices/female_cheekbone@2x.png": 13884,
	"./slices/female_chin@2x.png": 88557,
	"./slices/female_chin_tip@2x.png": 64985,
	"./slices/female_forehead@2x.png": 9106,
	"./slices/female_lower_face@2x.png": 65577,
	"./slices/female_mandible@2x.png": 76880,
	"./slices/female_mandibular_angle@2x.png": 73902,
	"./slices/female_masseter@2x.png": 35613,
	"./slices/female_ophryon@2x.png": 82104,
	"./slices/female_temple@2x.png": 11928,
	"./slices/fu_eight_head_body.png": 73751,
	"./slices/fu_five_head_body.png": 45069,
	"./slices/fu_nine_head_body.png": 95484,
	"./slices/fu_seven_head_body.png": 48221,
	"./slices/fu_six_head_body.png": 59190,
	"./slices/glasses_nor@2x.png": 13054,
	"./slices/glasses_sel@2x.png": 48019,
	"./slices/haircolor_nor@2x.png": 39127,
	"./slices/haircolor_sel@2x.png": 73341,
	"./slices/hairstyle_nor@2x.png": 98442,
	"./slices/hairstyle_sel@2x.png": 94811,
	"./slices/hat_nor@2x.png": 69796,
	"./slices/hat_sel@2x.png": 40556,
	"./slices/head_of_nose@2x.png": 24574,
	"./slices/icon_camera_nor.png": 73492,
	"./slices/icon_clear_nor.png": 56307,
	"./slices/icon_clothing_collection_sel.svg": 14126,
	"./slices/icon_drawer_audition.png": 70528,
	"./slices/icon_drawer_audition@2x.png": 96721,
	"./slices/icon_drawer_audition_active.png": 86111,
	"./slices/icon_drawer_history.png": 45826,
	"./slices/icon_drawer_history_active.png": 52515,
	"./slices/icon_edit_back to homepage@2x.png": 24362,
	"./slices/icon_female_nor.png": 17635,
	"./slices/icon_female_sel.png": 42474,
	"./slices/icon_forword_nor.png": 53616,
	"./slices/icon_home_action_library.png": 64466,
	"./slices/icon_home_avatar_camera.png": 18386,
	"./slices/icon_home_avatar_female.png": 21238,
	"./slices/icon_home_avatar_male.png": 51941,
	"./slices/icon_home_cloth_material.png": 16638,
	"./slices/icon_home_emoji_template.png": 49056,
	"./slices/icon_home_picture_template.png": 66950,
	"./slices/icon_home_tts_drive.png": 41613,
	"./slices/icon_home_video_template.png": 38436,
	"./slices/icon_homepage_gender_female@2x.png": 57097,
	"./slices/icon_homepage_gender_male@2x.png": 48656,
	"./slices/icon_homepage_image@2x.png": 73163,
	"./slices/icon_homepage_saveimage@2x.png": 4132,
	"./slices/icon_homepage_scan@2x.png": 8798,
	"./slices/icon_interaction_function_nor@2x.png": 60332,
	"./slices/icon_interaction_function_sel@2x.png": 61904,
	"./slices/icon_interaction_history_nor@2x.png": 72652,
	"./slices/icon_interaction_history_sel@2x.png": 85111,
	"./slices/icon_loading.png": 98810,
	"./slices/icon_logo_avatar.png": 13499,
	"./slices/icon_logo_avatar1.png": 39533,
	"./slices/icon_male_nor.png": 41394,
	"./slices/icon_male_sel.png": 64494,
	"./slices/icon_overall_empty@3x.png": 80251,
	"./slices/icon_popup_abnormal@3x.png": 43368,
	"./slices/icon_popup_cancel send@3x.png": 94143,
	"./slices/icon_popup_voice@3x.png": 9778,
	"./slices/icon_send_abled.svg": 28907,
	"./slices/icon_send_active.png": 72786,
	"./slices/icon_send_disable.png": 42733,
	"./slices/icon_send_disable.svg": 387,
	"./slices/icon_sidebar_accessories_nor@2x.png": 31952,
	"./slices/icon_sidebar_accessories_sel@2x.png": 96333,
	"./slices/icon_sidebar_clothes_nor@2x.png": 13439,
	"./slices/icon_sidebar_clothes_sel@2x.png": 38529,
	"./slices/icon_sidebar_face_nor@2x.png": 89812,
	"./slices/icon_sidebar_face_sel@2x.png": 35556,
	"./slices/icon_sidebar_shoes_nor@2x.png": 51803,
	"./slices/icon_sidebar_shoes_sel@2x.png": 98825,
	"./slices/icon_sidebar_trousers_nor@2x.png": 28852,
	"./slices/icon_sidebar_trousers_sel@2x.png": 25764,
	"./slices/icon_tab2_custom@2x.png": 1053,
	"./slices/icon_tab2_download.png": 93590,
	"./slices/icon_tab2_selected@2x.png": 48377,
	"./slices/icon_talk_delete.svg": 57868,
	"./slices/icon_talk_pause.svg": 17908,
	"./slices/icon_talk_play.svg": 76790,
	"./slices/icon_talk_voice.svg": 27633,
	"./slices/icon_talk_voice_active.svg": 62517,
	"./slices/icon_toast_loading.png": 16381,
	"./slices/icon_turning.png": 91783,
	"./slices/icon_voice_nor@3x.png": 673,
	"./slices/icon_withdraw_nor.png": 85951,
	"./slices/lipcolor_nor@2x.png": 43105,
	"./slices/lipcolor_sel@2x.png": 38820,
	"./slices/lipmakeup_nor@2x.png": 64990,
	"./slices/lipmakeup_sel@2x.png": 84428,
	"./slices/lips_nor@2x.png": 4010,
	"./slices/lips_sel@2x.png": 32155,
	"./slices/logo_avatar.png": 10190,
	"./slices/logo_avatarX.png": 775,
	"./slices/lower_eyelid_inner@2x.png": 13083,
	"./slices/lower_eyelid_mid@2x.png": 22813,
	"./slices/lower_eyelid_outside@2x.png": 9965,
	"./slices/lower_lip@2x.png": 57693,
	"./slices/male_cheek@2x.png": 48782,
	"./slices/male_cheekbone@2x.png": 69919,
	"./slices/male_chin@2x.png": 51640,
	"./slices/male_chin_tip@2x.png": 25338,
	"./slices/male_forehead@2x.png": 80517,
	"./slices/male_lower_face@2x.png": 22710,
	"./slices/male_mandible@2x.png": 82176,
	"./slices/male_mandibular_angle@2x.png": 63974,
	"./slices/male_masseter@2x.png": 97208,
	"./slices/male_ophryon@2x.png": 85083,
	"./slices/male_temple@2x.png": 58358,
	"./slices/mentolabial_sulcus@2x.png": 63868,
	"./slices/middle_lip_down@2x.png": 23870,
	"./slices/middle_lip_up@2x.png": 43152,
	"./slices/mouth@2x.png": 93510,
	"./slices/necklace_nor@2x.png": 89871,
	"./slices/necklace_sel@2x.png": 80449,
	"./slices/nose@2x.png": 61989,
	"./slices/nose_bridge@2x.png": 40442,
	"./slices/nose_nor@2x.png": 45698,
	"./slices/nose_root@2x.png": 75397,
	"./slices/nose_sel@2x.png": 55515,
	"./slices/nose_wing@2x.png": 62602,
	"./slices/rouge_nor@2x.png": 48324,
	"./slices/rougecolor_nor@2x.png": 28086,
	"./slices/rougecolor_sel@2x.png": 74483,
	"./slices/shoes_nor@2x.png": 40727,
	"./slices/shoes_sel@2x.png": 38854,
	"./slices/shorts_nor@2x.png": 96189,
	"./slices/shorts_sel@2x.png": 29538,
	"./slices/side_of_nose@2x.png": 33882,
	"./slices/sidebar_body_nor@2x.png": 11767,
	"./slices/sidebar_body_sel@2x.png": 5852,
	"./slices/skin_nor@2x.png": 96173,
	"./slices/skin_sel@2x.png": 67006,
	"./slices/skirts_nor@2x.png": 55788,
	"./slices/skirts_sel@2x.png": 6815,
	"./slices/suit_nor@2x.png": 10822,
	"./slices/suit_sel@2x.png": 91421,
	"./slices/sweater_nor@2x.png": 64948,
	"./slices/sweater_sel@2x.png": 79199,
	"./slices/tab1_body_nor@2x.png": 66909,
	"./slices/tab1_body_sel@2x.png": 95628,
	"./slices/trousers_nor@2x.png": 84899,
	"./slices/trousers_sel@2x.png": 91777,
	"./slices/upper_eyelid_inner@2x.png": 81223,
	"./slices/upper_eyelid_mid@2x.png": 6563,
	"./slices/upper_eyelid_outside@2x.png": 58369,
	"./slices/upper_lip@2x.png": 48264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;